"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftCandidatesDto = instanceOfShiftCandidatesDto;
exports.ShiftCandidatesDtoFromJSON = ShiftCandidatesDtoFromJSON;
exports.ShiftCandidatesDtoFromJSONTyped = ShiftCandidatesDtoFromJSONTyped;
exports.ShiftCandidatesDtoToJSON = ShiftCandidatesDtoToJSON;
exports.ShiftCandidatesDtoToJSONTyped = ShiftCandidatesDtoToJSONTyped;
const ShiftCandidateDto_1 = require("./ShiftCandidateDto");
/**
 * Check if a given object implements the ShiftCandidatesDto interface.
 */
function instanceOfShiftCandidatesDto(value) {
    if (!('candidates' in value) || value['candidates'] === undefined)
        return false;
    return true;
}
function ShiftCandidatesDtoFromJSON(json) {
    return ShiftCandidatesDtoFromJSONTyped(json, false);
}
function ShiftCandidatesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'candidates': (json['candidates'].map(ShiftCandidateDto_1.ShiftCandidateDtoFromJSON)),
    };
}
function ShiftCandidatesDtoToJSON(json) {
    return ShiftCandidatesDtoToJSONTyped(json, false);
}
function ShiftCandidatesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'candidates': (value['candidates'].map(ShiftCandidateDto_1.ShiftCandidateDtoToJSON)),
    };
}
//# sourceMappingURL=ShiftCandidatesDto.js.map